import { Block, Box, transitionsDelay } from '../../../styles/basicStyles';
import { breakpoints } from '../../../styles/breakpoints';
import styled, { css } from 'styled-components';

export const ItemWrapper = styled(Box)<{n: number}>`
  aspect-ratio: 1 / 1;
  width: 33.333%;

  @media ${breakpoints.md} {
    width: 50%;
    order: ${({ n }) => n};

    &:nth-child(4n - 1) {
      order: ${({ n }) => n % 2 !== 0 ? n + 1 : 0};
    }

    &:nth-child(4n) {
      order: ${({ n }) => n % 2 === 0 ? n - 1 : 0};
    }
  }

  @media ${breakpoints.xs} {
    width: 100%;
    order: unset !important;
  }
`;

export const ItemBgWrapper = styled.div`
  width: 100%;
  height: 100%;

  & .react-reveal {
    width: 100%;
    height: 100%;
  }
`;

export const IconWrapper = styled(Box)<{color?: string, opacity?: number}>`
  position: relative;
  align-items: center;
  justify-content: center;
  width: unset;
  
  &:before {
    content: '';
    position: absolute;
    height: 2.813rem;
    width: 2.813rem;
    border-radius: 50%;
    background-color: ${({ theme, color }) => color ? color : theme.colors.purple}; 
    opacity: ${({ opacity }) => opacity ? opacity : 1};
  }
`;

export const ItemBackgroundImage = styled(Block)`
  background-repeat: no-repeat;
  background-size: cover;
  background-position: ${({ bgPosition }) => bgPosition ? bgPosition : 'center'};
`;

export const ItemsWrapper = styled(Block)`
  display: flex;
  flex-flow: row wrap;
  flex-wrap: wrap;
`;

export const UnderlineText = styled.a`
  text-decoration: underline;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.black};
  cursor: pointer;
  transition: color ${transitionsDelay} linear;

  &:hover{
    color:  ${({ theme }) => theme.colors.black07};
  }
`;

export const PositionWrapper = styled(Box)`
  border-radius: 0.625rem;
  background-color: ${({ theme }) => theme.colors.desertStorm};
  justify-content: space-between;
  margin-bottom: 0.5rem;

  & .react-reveal {
    width: 100%;
    height: 100%;
  }
`;

export const SeparatorDot = styled.span<{color?: string}>`
  height: 0.313rem;
  width: 0.313rem;
  border-radius: 50%;
  vertical-align: middle;
  display: inline-block;
  margin-left: 0.688rem;
  margin-right: 0.688rem;
  background-color: ${({ theme, color }) => color ? color :  theme.colors.coolGrey}; 
`;

export const WeValueCircle1 = styled.div`
  position: absolute;
  top: 3.125rem;
  left: -12rem;
  width: 15rem;
  height: 15rem;
  border-radius: 50%;
  background: radial-gradient(50% 50% at 50% 50%, rgba(100, 255, 227, 0.40) 0%, rgba(100, 255, 227, 0.40) 100%);
  filter: blur(9.375rem);
  z-index: 1;
  // This code is to fix issues with the gradient in IOS
  transform: translateZ(0);
  backface-visibility: hidden;

  @media ${breakpoints.md} {
    left: -8rem;
    top: 6.75rem;
  }
`;

export const WeValueCircle2 = styled.div`
  position: absolute;
  top: 9.375rem;
  left: -2rem;
  width: 17.5rem;
  height: 17.5rem;
  border-radius: 50%;
  background: radial-gradient(50% 50% at 50% 50%, rgba(129, 108, 255, 0.30) 0%, rgba(129, 108, 255, 0.30) 100%);
  filter: blur(9.375rem);
  z-index: 1;
  // This code is to fix issues with the gradient in IOS
  transform: translateZ(0);
  backface-visibility: hidden;

  @media ${breakpoints.md} {
    top: 13rem;
  }
`;

export const WorkingAtCodepointLine = styled.div<{ started: boolean }>`
  position: absolute;
  left: 0;
  bottom: -1.75rem;
  width: 100%;

  & svg {
    width: 100%;
    height: auto;
  }

  ${({ started }) => started ?
    css`
      display: block; 

      & path {
        stroke-dasharray: 500;
        stroke-dashoffset: 500;
        animation-duration: 2.8s;
        animation-name: dash;
        animation-iteration-count: 1;
        animation-delay: 0;
        animation-fill-mode: forwards;
      }

      @keyframes dash {
        to {
          stroke-dashoffset: 0;
        }
      }
    `
    :
    css`
      display: none;
    `
  }
`;

export const WeValueBg = styled(Block)`
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
`;
